<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
export default defineNuxtComponent({
	name: "GizmoContentGridDynamic",
	mixins: [GizmoComponentMixin],

	computed: {
		division() {
			if (this.content.filter) return Object.keys(this.content.filter)[0];
			return "";
		},
		category() {
			return useRoute().query.category || this.content.filter?.[this.division].category;
		},
		subcategories() {
			if (this.content.filter) {
				const fromQuery = useRoute().query.subcategories?.split(",") || [];
				const fromGizmo = this.content.filter[this.division].subcategories || [];
				return Array.from(new Set([...fromQuery, ...fromGizmo].filter((x) => x)));
			} else {
				return [];
			}
		},
	},
});
</script>

<template>
	<ContentGridDynamic
		:division="division"
		:initial-category="category"
		:initial-subcategories="subcategories"
		:max-items="content.maxItems"
		:infinityScroll="content.pagination"
		:pinned="content.pinned"
		:show-filters="content.showFilters"
		:category-page="content.categoryPage"
		:load-more-button="content.loadMoreButton"
	/>
</template>

<style scoped lang="scss"></style>
